import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles/salesExperience.css";
import { flushVisits } from "./utils/offlineVisits";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<React.StrictMode><App /></React.StrictMode>);
window.addEventListener("online",()=>flushVisits());
if(navigator.onLine)flushVisits();

// Refresh direct browser sessions and installed PWAs when a new bundle lands.
const BUILD_VERSION_KEY = "ebek-crm-build-version";
async function refreshForNewBuild() {
  try {
    const response = await fetch(`/build-version.json?t=${Date.now()}`, { cache: "no-store" });
    if (!response.ok) return;
    const { version } = await response.json();
    if (!version) return;
    const previous = localStorage.getItem(BUILD_VERSION_KEY);
    localStorage.setItem(BUILD_VERSION_KEY, version);
    if (previous && previous !== version) window.location.reload();
  } catch {
    // Offline clients retry on the next interval, focus, or visibility change.
  }
}

if (process.env.NODE_ENV === "production") {
  refreshForNewBuild();
  window.setInterval(refreshForNewBuild, 60 * 1000);
  window.addEventListener("focus", refreshForNewBuild);
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") refreshForNewBuild();
  });
}

if (process.env.NODE_ENV === "production" && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch((error) => {
      console.warn("Service worker registration failed", error);
    });
  });
} else if ("serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations()
    .then((registrations) => registrations.forEach((registration) => registration.unregister()))
    .catch(() => {});
}

